"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _classnames = _interopRequireDefault(require("classnames"));

var _misc = require("HubStyleTokens/misc");

var _sizes = require("HubStyleTokens/sizes");

var _theme = require("HubStyleTokens/theme");

var _times = require("HubStyleTokens/times");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIScrollContainer = _interopRequireDefault(require("../scroll/UIScrollContainer"));

var _UISection = _interopRequireDefault(require("../section/UISection"));

var _Styles = require("../utils/Styles");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: ", ";\n  background-color: ", ";\n  border-collapse: collapse;\n  width: 100%;\n  ", ";\n\n  th,\n  td {\n    border-color: ", ";\n    border-style: solid;\n    border-width: 1px 0 0;\n    line-height: normal;\n    vertical-align: middle;\n  }\n\n  thead {\n    th {\n      ", ";\n      font-size: ", ";\n      background-color: ", ";\n      color: ", ";\n      height: ", ";\n      padding-bottom: ", ";\n      padding-left: ", ";\n      padding-right: ", ";\n      padding-top: ", ";\n      text-align: left;\n      text-transform: uppercase;\n      vertical-align: ", ";\n    }\n  }\n\n  tfoot {\n    td,\n    th {\n      ", ";\n      height: ", ";\n      padding: ", " ", ";\n      text-align: left;\n    }\n  }\n\n  tbody {\n    td {\n      hyphens: auto;\n      height: ", ";\n      overflow-wrap: break-word; /* prevent overflow in Chrome 55+ (issue #1494) */\n      padding: ", " ", ";\n      vertical-align: ", ";\n\n      .private-tag--inline {\n        vertical-align: ", "; /* issue #1267 */\n      }\n    }\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  /* HACK: contextual styling for Tables-in-Cards */\n  .private-card & {\n    border: 0;\n    border-radius: inherit;\n\n    thead {\n      th,\n      .private-table-sort-toggle {\n        background-color: transparent;\n        border-top: 0;\n      }\n    }\n  }\n\n  /* HACK: contextual styling for Tables-in-Panels */\n  .private-panel__body & {\n    ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var TableScrollContainer = (0, _styledComponents.default)(_UIScrollContainer.default).withConfig({
  displayName: "UITable__TableScrollContainer",
  componentId: "h0uzdr-0"
})(_templateObject(), function (_ref) {
  var scrollDirection = _ref.scrollDirection;
  return scrollDirection === 'both' && '100%';
});

var Table = _styledComponents.default.table.withConfig({
  displayName: "UITable__Table",
  componentId: "h0uzdr-1"
})(_templateObject2(), _sizes.TABLE_DEFAULT_FONT_SIZE, _theme.TABLE_BACKGROUND_COLOR, function (props) {
  return (props.flush || props.responsive) && "&& { margin-bottom: 0; }";
}, _theme.TABLE_BORDER_COLOR, _Styles.FONT_FAMILIES.medium, _sizes.TABLE_HEADER_FONT_SIZE, _theme.TABLE_HEADER_BACKGROUND_COLOR, _theme.BASE_FONT_COLOR, _sizes.TABLE_HEADER_HEIGHT, _sizes.TABLE_HEADER_PADDING_BOTTOM, _sizes.TABLE_DEFAULT_PADDING_X, _sizes.TABLE_DEFAULT_PADDING_X, _sizes.TABLE_HEADER_PADDING_TOP, _misc.TABLE_HEADER_VERTICAL_ALIGNMENT, _Styles.FONT_FAMILIES.demibold, _sizes.TABLE_CELL_HEIGHT, _sizes.TABLE_DEFAULT_PADDING_Y, _sizes.TABLE_DEFAULT_PADDING_X, _sizes.TABLE_CELL_HEIGHT, _sizes.TABLE_DEFAULT_PADDING_Y, _sizes.TABLE_DEFAULT_PADDING_X, _misc.TABLE_CELL_VERTICAL_ALIGNMENT, _misc.TABLE_CELL_VERTICAL_ALIGNMENT, function (props) {
  return props.bordered !== false && "\n      border-color: " + _theme.TABLE_BORDER_COLOR + ";\n      border-style: solid;\n      border-width: 0 1px 1px;\n  ";
}, function (props) {
  return props.condensed && "\n      thead th {\n        height: " + _sizes.TABLE_HEADER_HEIGHT + ";\n        padding-bottom: " + _sizes.TABLE_COMPACT_PADDING_Y + ";\n        padding-top: " + _sizes.TABLE_COMPACT_PADDING_Y + "\n      }\n\n      tbody {\n        td, th {\n          height: " + _sizes.TABLE_COMPACT_CELL_HEIGHT + ";\n          padding-bottom: " + _sizes.TABLE_COMPACT_PADDING_Y + ";\n          padding-top: " + _sizes.TABLE_COMPACT_PADDING_Y + ";\n        }\n      }\n  ";
}, function (props) {
  return props.hover && "\n      tbody {\n        tr {\n          transition: background-color " + _times.MICRO_TRANSITION_TIMING + " ease-out;\n        }\n        tr:hover {\n          background-color: " + _theme.TABLE_ROW_HOVER_BACKGROUND_COLOR + ";\n        }\n      }\n  ";
}, function (props) {
  return props.truncated && "\n      table-layout: fixed;\n\n      td,\n      th {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n  ";
}, function (props) {
  return props.bordered !== true && "border-width: 0 0 1px;";
});

var UITable = (0, _react.forwardRef)(function (props, ref) {
  var bordered = props.bordered,
      children = props.children,
      className = props.className,
      condensed = props.condensed,
      flush = props.flush,
      height = props.height,
      hover = props.hover,
      responsive = props.responsive,
      responsiveWrapperClassName = props.responsiveWrapperClassName,
      ScrollContainer = props.ScrollContainer,
      truncated = props.truncated,
      rest = (0, _objectWithoutProperties2.default)(props, ["bordered", "children", "className", "condensed", "flush", "height", "hover", "responsive", "responsiveWrapperClassName", "ScrollContainer", "truncated"]);
  var computedClassName = (0, _classnames.default)('table private-table', className, {
    'table-bordered': bordered,
    'table-condensed private-table--condensed': condensed
  });

  var renderedTable = _react.default.createElement(Table, (0, _extends2.default)({}, rest, {
    className: computedClassName,
    bordered: bordered,
    condensed: condensed,
    flush: flush,
    hover: hover,
    ref: ref,
    responsive: responsive,
    truncated: truncated
  }), children);

  return responsive ? _react.default.createElement(_UISection.default, {
    className: (0, _classnames.default)(responsiveWrapperClassName, 'table-responsive', 'private-scroll__wrapper--tables'),
    flush: flush,
    height: height
  }, _react.default.createElement(ScrollContainer, {
    scrollDirection: height != null ? 'both' : 'horizontal'
  }, renderedTable)) : renderedTable;
});
UITable.propTypes = {
  bordered: _propTypes.default.oneOf([true, false, 'auto']),
  children: _propTypes.default.node.isRequired,
  condensed: _propTypes.default.bool.isRequired,
  flush: _propTypes.default.bool.isRequired,
  height: _UISection.default.propTypes.height,
  hover: _propTypes.default.bool.isRequired,
  responsive: _propTypes.default.bool.isRequired,
  responsiveWrapperClassName: _propTypes.default.string,
  ScrollContainer: _propTypes.default.elementType.isRequired,
  truncated: _propTypes.default.bool.isRequired
};
UITable.defaultProps = {
  bordered: 'auto',
  condensed: false,
  flush: false,
  hover: true,
  responsive: true,
  ScrollContainer: TableScrollContainer,
  truncated: false
};
UITable.displayName = 'UITable';
var _default = UITable;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/table/UITable.js
// module id = 846
// module chunks = 209 210 211 212